import styled from "styled-components";
import { getPropertyByMedia, getThemeTokenParser } from "../helpers";
export const Picture = styled.picture `
	display: flex;
	align-items: center;
	justify-content: center;

	${({ backgroundColor }) => getPropertyByMedia("background-color", getThemeTokenParser(backgroundColor, "colors"))}
	${({ borderRadius }) => getPropertyByMedia("border-radius", borderRadius)}
	${({ height }) => getPropertyByMedia("height", height)}
	${({ width }) => getPropertyByMedia("width", width)}
	${({ padding }) => getPropertyByMedia("padding", padding)}

	overflow: hidden;

	img {
		${({ imageFit }) => {
    if (imageFit === "horizontal")
        return 'width: 100%;';
    if (imageFit === "vertical")
        return 'height: 100%;';
    return 'width: 100%; height: 100%;';
}}
	}
`;
//# sourceMappingURL=styles.js.map